export default __webpack_public_path__ + "static/media/whatsapp_icon.73ea6113.png";